import { render } from "./FazerReclamacao.vue?vue&type=template&id=02d17488&scoped=true"
import script from "./FazerReclamacao.vue?vue&type=script&lang=js"
export * from "./FazerReclamacao.vue?vue&type=script&lang=js"

import "./FazerReclamacao.vue?vue&type=style&index=0&id=02d17488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d17488"]])

export default __exports__